import dayjs, {formatLocaleDate} from '@/dayjs'
import {
    StyledAgendaScheduleDate,
    StyledAgendaScheduleDay,
    StyledAgendaScheduleDayNumber
} from '@/features/agenda/components/agenda-schedule-date/style'
import {useAgendaNavigation} from '@/features/agenda/hooks/useAgendaNavigation'
import {capitalize} from '@/utilities/helpers'

interface AgendaScheduleDateProps {
    date: Date
}

export const AgendaScheduleDate = ({date}: AgendaScheduleDateProps) => {
    const {
        params: {date: selectedDate}
    } = useAgendaNavigation()

    const dayNumber = formatLocaleDate(date, 'DD')
    const day = formatLocaleDate(date, 'ddd')
    const month = formatLocaleDate(date, 'MMM')

    const isSelected = dayjs(selectedDate).isSame(dayjs(date), 'day')

    return (
        <StyledAgendaScheduleDate align="center" gap={2}>
            <StyledAgendaScheduleDayNumber $isSelected={isSelected}>{dayNumber}</StyledAgendaScheduleDayNumber>
            <StyledAgendaScheduleDay>
                {month.toUpperCase()}, {capitalize(day)}
            </StyledAgendaScheduleDay>
        </StyledAgendaScheduleDate>
    )
}
